import { Client } from '@/services/types'
import { ClientsMutations } from './types'

const mutations: ClientsMutations = {
  setClients(state, clients: Client[]) {
    state.clients = clients
  },
}

export default mutations
